import React from "react";
import styles from "./PasswordChange.module.css";
import authContext from "../../store/auth-context";

const PasswordChange: React.FC<{ cancelFunction: () => void }> = ({
  cancelFunction,
}) => {
  const authCtx = React.useContext(authContext);
  const [newPass, setNewPass] = React.useState({ pass: "", isTouched: false });
  const [confirmPass, setConfirmPass] = React.useState({
    pass: "",
    isTouched: false,
  });
  const [statusMessage, setStatusMessage] = React.useState(
    authCtx.isDeveloper
      ? "This feature is not available to the developer account"
      : ""
  );

  const passwordConfirmIsValid =
    confirmPass.pass.length >= 6 && confirmPass.pass === newPass.pass;

  function handleChange(e: any) {
    setNewPass((prev) => ({ ...prev, pass: e.target.value }));
  }
  function handleBlur() {
    setNewPass((prev) => ({ ...prev, isTouched: true }));
  }
  function confirmPassChange(e: any) {
    setConfirmPass({ pass: e.target.value, isTouched: true });
  }

  function reset() {
    setNewPass({
      pass: "",
      isTouched: false,
    });
    setConfirmPass({
      pass: "",
      isTouched: false,
    });
  }

  const passwordInvalid = newPass.pass.length < 7 || newPass.pass.length > 25;

  function submitHandler(e: any) {
    e.preventDefault();
    if (passwordInvalid || !passwordConfirmIsValid || authCtx.isDeveloper) {
      return;
    }
    fetch(
      "https://identitytoolkit.googleapis.com/v1/accounts:update?key=AIzaSyAasBNs63AV_6TlQIsEbmOQZa_ffeo9qn0",
      {
        method: "POST",
        body: JSON.stringify({
          idToken: localStorage.getItem("token"),
          password: newPass,
          returnSecureToken: false,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          return res.json().then((data) => {
            throw new Error(data.error.message);
          });
        }
      })
      .then(() => {
        reset();
        setStatusMessage("Password Successfully Changed");
      })
      .catch((err) => {
        setStatusMessage(err.toISOString());
      });
  }

  return (
    <>
      <h2>Change Password</h2>
      <form className={styles.password}>
        <input
          type="password"
          max="25"
          min="7"
          placeholder="Password"
          value={newPass.pass}
          onChange={handleChange}
          onBlur={handleBlur}
          name="newPass"
        />
        <input
          type="password"
          placeholder="Confirm Password"
          value={confirmPass.pass}
          onChange={confirmPassChange}
        />
        {confirmPass.isTouched && newPass.pass !== confirmPass.pass && (
          <p className={styles.warning}>Passwords must match</p>
        )}
        {newPass.isTouched && newPass && passwordInvalid && (
          <p className={styles.warning}>
            {newPass.pass.length > 25
              ? "Password must be less than 26 characters."
              : "Password must be greater than 6 characters."}
          </p>
        )}
        <div className={styles["button-container"]}>
          <button
            className={styles.submit}
            onClick={submitHandler}
            disabled={authCtx.isDeveloper}
            data-testid="confirmBtn"
          >
            Change Password
          </button>
          <button className={styles.submit} onClick={cancelFunction}>
            Cancel
          </button>
        </div>
      </form>
      {statusMessage && <p className={styles.warning}>{statusMessage}</p>}
    </>
  );
};
export default PasswordChange;
